import { financesConstants } from '../../constants/finances';
import { history } from '../../routes/AppRouter';

export const redirectToPaymentsData = () => next => action => {
  if (action.type === financesConstants.REDIRECT_TO_PAYMENTS_DATA) {
    if(action.data) {
      const { pathname } = action.data;
      if(pathname && pathname === '/profile/payment-data') {
        history.push(pathname);
      }
    }
  }

  return next(action);
};
